<div class="rs-successfull-validation-code">
  <span class="rs-header">{{ 'registration.validateCode.validatedCode.header' | translate }}</span>
  <span class="rs-label">{{ 'registration.validateCode.validatedCode.label' | translate }}</span>
  <span class="rs-data">{{ registrationTypeData }}</span>
</div>
